
// Create document integration code if documents were uploaded
export function generateDocumentIntegration(uploadedDocuments: File[]): string {
  if (uploadedDocuments.length === 0) {
    return '';
  }
  
  return `
// Document Integration
const documentSources = [
  ${uploadedDocuments.map(doc => `"${doc.name}"`).join(',\n  ')}
];

async function processDocuments() {
  console.log("Processing documents:", documentSources);
  // In a real implementation, this would process and incorporate 
  // the uploaded documents into the agent's knowledge base
}

// Initialize document processing
await processDocuments();`;
}

// Generate database schema extraction code
export function generateDatabaseSchemaExtraction(schemaDefinition: string): string {
  if (!schemaDefinition) {
    return '';
  }
  
  return `
// Database Schema Integration
const databaseSchema = ${JSON.stringify(schemaDefinition, null, 2)};

function extractDataFromDocuments(documents, schema) {
  console.log("Extracting data from documents based on schema:", schema);
  
  // In a real implementation, this would:
  // 1. Parse the schema to understand table structure and relationships
  // 2. Apply NLP techniques to extract relevant data from documents
  // 3. Validate extracted data against schema constraints
  // 4. Transform data into a format suitable for database insertion
  
  return {
    extractedData: {},
    validationErrors: []
  };
}

// Process documents with schema validation
const extractionResult = extractDataFromDocuments(documentSources, databaseSchema);
console.log("Extraction complete:", extractionResult);

// Handle any validation errors
if (extractionResult.validationErrors.length > 0) {
  console.error("Validation errors found:", extractionResult.validationErrors);
}`;
}

// Generate a system prompt for data extraction from documents
export function generateDataExtractionPrompt(schemaDefinition: string): string {
  if (!schemaDefinition) {
    return '';
  }
  
  return `
You are a data extraction expert specializing in Standard Operating Procedures (SOPs).
Your task is to analyze the provided SOP documents and extract data that matches the provided database schema.

DATABASE SCHEMA:
${schemaDefinition}

INSTRUCTIONS:
1. Analyze the uploaded document carefully
2. Extract all relevant data that should be stored according to the schema
3. For each table in the schema, identify required fields and extract values for them
4. Validate the data format, especially ensuring dates match the expected format (YYYY-MM-DD)
5. For any references between tables, ensure the relationship is maintained
6. Generate a structured JSON output that matches the schema structure
7. Return ONLY valid JSON that can be parsed and used to generate SQL INSERT statements

Output the extracted data in the following JSON format:
{
  "tables": {
    "table_name_1": [
      {
        "column_1": "value_1",
        "column_2": "value_2",
        ...
      },
      ...
    ],
    "table_name_2": [
      ...
    ]
  },
  "validationErrors": [
    {
      "table": "table_name",
      "column": "column_name",
      "value": "invalid_value",
      "error": "Error description"
    },
    ...
  ]
}
`;
}
